import React from "react";
import { motion } from "framer-motion";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export default function Contato() {
  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-yellow-50 to-white flex flex-col justify-center items-center px-6 py-16"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Seção Principal */}
      <div className="max-w-4xl text-center">
        <h2 className="text-4xl font-extrabold text-gray-800 tracking-wide">
          Entre em Contato
        </h2>
        
        {/* Linha Decorativa */}
        <div className="w-24 h-1 bg-yellow-500 mx-auto my-4"></div>

        <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto">
          Ficarei feliz em ajudá-lo a encontrar o imóvel dos seus sonhos! 📍
          Entre em contato pelos meios abaixo e vamos conversar.
        </p>
      </div>

      {/* Cartões de Contato */}
      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
        
        {/* Telefone */}
        <motion.div
          className="bg-white shadow-lg rounded-lg p-6 border border-yellow-300 hover:shadow-xl transform hover:scale-105 transition"
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex justify-center mb-3">
            <FaPhone size={40} color="#FACC15" />
          </div>
          <h3 className="text-xl font-semibold text-gray-800">Telefone</h3>
          <p className="text-gray-600 mt-2">📞 (11) 99999-9999</p>
        </motion.div>

        {/* E-mail */}
        <motion.div
          className="bg-white shadow-lg rounded-lg p-6 border border-yellow-300 hover:shadow-xl transform hover:scale-105 transition"
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex justify-center mb-3">
            <FaEnvelope size={40} color="#FACC15" />
          </div>
          <h3 className="text-xl font-semibold text-gray-800">E-mail</h3>
          <p className="text-gray-600 mt-2">✉️ contato@marineideimoveis.com</p>
        </motion.div>

        {/* Endereço */}
        <motion.div
          className="bg-white shadow-lg rounded-lg p-6 border border-yellow-300 hover:shadow-xl transform hover:scale-105 transition"
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex justify-center mb-3">
            <FaMapMarkerAlt size={40} color="#FACC15" />
          </div>
          <h3 className="text-xl font-semibold text-gray-800">Endereço</h3>
          <p className="text-gray-600 mt-2">📍 </p>
        </motion.div>

      </div>
    </motion.div>
  );
}
